if (!customElements.get('social-proof-toast')) {
  customElements.define(
    'social-proof-toast',
    class SocialProofToast extends HTMLElement {
      constructor() {
        super();
        this.endpoint = this.dataset.endpoint || '';
        this.productId = this.dataset.productId || '';
        this.minCount = parseInt(this.dataset.minCount, 10) || 0;
        this.days = parseInt(this.dataset.days, 10) || 30;
        this.delay = parseInt(this.dataset.delay, 10) || 3;
        this.autoHide = parseInt(this.dataset.autoHide, 10) || 0;
        this.template = this.dataset.template || '';
        this.dismissKey = `gandini:social-proof-dismissed:${this.productId}`;

        this.textElement = this.querySelector('[data-social-proof-text]');
        this.closeButton = this.querySelector('[data-social-proof-close]');
        this.progressBar = this.querySelector('[data-social-proof-progress]');
      }

      connectedCallback() {
        if (this.closeButton) this.closeButton.addEventListener('click', this.dismiss.bind(this));

        if (this.autoHide > 0) {
          this.style.setProperty('--social-proof-duration', `${this.autoHide}s`);
        }

        if (window.Shopify && window.Shopify.designMode) {
          this.classList.add('social-proof--preview');
          this.render(this.minCount > 0 ? this.minCount : 26);
          this.show();
          return;
        }

        if (this.progressBar) {
          this.progressBar.addEventListener('animationend', () => this.hide(false));
        }

        if (this.isDismissed()) return;
        if (!this.endpoint || !this.productId) return;

        this.registerView();
      }

      isDismissed() {
        try {
          return sessionStorage.getItem(this.dismissKey) === '1';
        } catch (error) {
          return false;
        }
      }

      dismiss() {
        this.hide(true);
      }

      hide(persist) {
        if (!this.hasAttribute('open') || this.hasAttribute('closing')) return;

        if (persist) {
          try {
            sessionStorage.setItem(this.dismissKey, '1');
          } catch (error) {
            // Storage unavailable: fail silently.
          }
        }

        this.setAttribute('closing', '');
        setTimeout(() => {
          this.removeAttribute('closing');
          this.removeAttribute('open');
        }, 320);
      }

      getVisitorId() {
        const key = 'gandini:visitor-id';
        try {
          let id = localStorage.getItem(key);
          if (!id) {
            id =
              typeof crypto !== 'undefined' && crypto.randomUUID
                ? crypto.randomUUID()
                : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
            localStorage.setItem(key, id);
          }
          return id;
        } catch (error) {
          return 'anonymous';
        }
      }

      async registerView() {
        try {
          const response = await fetch(this.endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              shop: window.Shopify ? window.Shopify.shop : window.location.hostname,
              product_id: this.productId,
              visitor_id: this.getVisitorId(),
              days: this.days,
            }),
          });

          if (!response.ok) return;

          const data = await response.json();
          const count = parseInt(data.count, 10);

          if (!Number.isFinite(count) || count < this.minCount) return;

          this.render(count);
          setTimeout(() => this.show(), this.delay * 1000);
        } catch (error) {
          // Tracking is non critical: never block the product page.
        }
      }

      render(count) {
        if (!this.textElement) return;

        const parts = this.template.replace('{days}', this.days).split('{count}');
        this.textElement.textContent = '';
        this.textElement.append(document.createTextNode(parts[0] || ''));

        const strong = document.createElement('strong');
        strong.className = 'social-proof__count';
        strong.textContent = count;
        this.textElement.append(strong);

        if (parts.length > 1) this.textElement.append(document.createTextNode(parts[1]));
      }

      show() {
        this.setAttribute('open', '');
      }
    },
  );
}
